import $ from 'jquery';
import Swiper from 'swiper';
import Navigation from 'swiper/modules/navigation.mjs';
import Pagination from 'swiper/modules/pagination.min.mjs';
import Autoplay from 'swiper/modules/autoplay.min.mjs';

 

const op__slide = new Swiper(".op__slide", {
    modules: [Autoplay,Pagination],
    loop: false,
    speed: 600,
    slidesPerView: 1,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true, 
    },
});

const wywslide__slider = new Swiper(".wywslide__slider", {
  modules: [Autoplay, Navigation, Pagination],
  speed: 1000,
  spaceBetween: 10,
  loop: true,
  slidesPerView: 1,
  autoplay: {
      delay: 6000,
      disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true, 
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    '600': {
      slidesPerView: 1,
    },
    '980': {
      slidesPerView: 2,
    },
    '1110': {
      slidesPerView: 2,
    },
    '1440': {
      slidesPerView: 3,
    },
}
});